import React from 'react';
import SearchBar from 'shared/lib/components/controls/search/searchBar';
import searchBackground from 'shared/assets/images/searchBackground.svg';
import ColumnCenterFlex from 'shared/lib/components/containers/columnCenterFlex';
import SearchWrapper from 'shared/lib/components/controls/search/searchWrapper';
import { useGeneralAdaptive } from 'shared/hooks/useGeneralAdaptive';
import FullTextCheckbox from 'shared/lib/components/controls/search/fullTextCheckbox';
import { Box } from '@mui/material';

export default function SearchBlock() {
  const { generalPaddingX, searchWrapperPaddingY } = useGeneralAdaptive();

  return (
    <ColumnCenterFlex
      sx={{
        display: 'flex',
        alignItems: 'center',
        py: searchWrapperPaddingY,
        px: generalPaddingX,
        backgroundImage: `url(${searchBackground})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }}
    >
      <SearchWrapper>
        <SearchBar placeholder="Что будем искать?"></SearchBar>
        <Box></Box>
      </SearchWrapper>
    </ColumnCenterFlex>
  );
}
